export default {
 homePage_00007: 'Por hacer',
 homePage_00020: 'Solicitud de reembolso',
 homePage_00021: 'Solicitud de factura personal',
 homePage_00022: 'Aplicación de factura grupal',
 homePage_00023: 'Factura de pago',
}